import { User } from '@/staff/models/user';

export class NylasUtils {
    static doesUserNeedReauth(user: User): boolean {
        return !!user.nylas_email && !user.is_nylas_email_active;
    }
}
